import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeone-process',
    templateUrl: './homeone-process.component.html',
    styleUrls: ['./homeone-process.component.scss']
})
export class HomeoneProcessComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Our Services",
            title: 'From Data Science to Turnkey Deployment, We Got it.',
            paragraphText: "Design your data intelligence workflow with us. Let us help you build, test and deploy vision intelligence for your specific business needs."
        }
    ]
    singleProcessBox: processBoxContent[] = [
        {
            img: 'https://imgvid.blob.core.windows.net/imgvid/step1.png',
            title: 'Step 1: Select',
            paragraphText: 'From wide-range of pre-trained/foundation models based on your requirements.',
            number: '1'
        },
        {
            img: 'https://imgvid.blob.core.windows.net/imgvid/step2.png',
            title: 'Step 2: Tune-up',
            paragraphText: 'Fine tune the model on your dataset to make it solve problem with high accuracy.',
            number: '2'
        },
        {
            img: 'https://imgvid.blob.core.windows.net/imgvid/step3.png',
            title: 'Step 3: Deploy',
            paragraphText: 'Connect your streaming data, like a camera, and automate webhook actions like IFTTT.',
            number: '3'
        }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class processBoxContent {
    img : string;
    title : string;
    paragraphText : string;
    number : string;
}